import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only show if consent hasn't been given
    const consent = localStorage.getItem("madrich_cookie_consent");
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setShow(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  function accept() {
    localStorage.setItem("madrich_cookie_consent", "accepted");
    localStorage.setItem("madrich_cookie_consent_date", new Date().toISOString());
    setShow(false);
  }

  function decline() {
    localStorage.setItem("madrich_cookie_consent", "essential_only");
    localStorage.setItem("madrich_cookie_consent_date", new Date().toISOString());
    setShow(false);
  }

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl shadow-slate-900/20 border border-slate-200 p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-slate-900 text-sm mb-1">We value your privacy</h3>
            <p className="text-xs text-slate-500 leading-relaxed">
              We use essential cookies to keep you logged in and make the site work. We do not use advertising or tracking cookies.
              By continuing, you agree to our use of essential cookies.{" "}
              <a href="/privacy" className="text-blue-600 hover:underline">Privacy Policy</a>
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <button
              onClick={decline}
              className="text-xs text-slate-500 px-4 py-2 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors"
            >
              Essential Only
            </button>
            <button
              onClick={accept}
              className="text-xs bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
